import { render, staticRenderFns } from "./logout-view.vue?vue&type=template&id=ebc02ea2&scoped=true&"
import script from "./logout-view.vue?vue&type=script&lang=ts&"
export * from "./logout-view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc02ea2",
  null
  
)

export default component.exports